const ICON_SIZE = {
  small: 14,
  medium: 18,
};

export default (theme) => ({
  infoIcon: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    color: theme.palette.textColor.white,
    fontWeight: 600,
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
  },
  customIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1,
    cursor: 'pointer',
    userSelect: 'none',
  },
  iconSmall: {
    width: ICON_SIZE.small,
    minWidth: ICON_SIZE.small,
    height: ICON_SIZE.small,
    fontSize: 10,
  },
  iconMedium: {
    width: ICON_SIZE.medium,
    minWidth: ICON_SIZE.medium,
    height: ICON_SIZE.medium,
    fontSize: 12,
  },
  hint: {
    backgroundColor: theme.palette.background.tooltip,
    color: theme.palette.textColor.white,
    fontSize: 12,
    lineHeight: 1.4,
    padding: '6px 10px',
    borderRadius: 6,
    maxWidth: 280,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 740px)': {
      maxWidth: 200,
    },
  },
  hintWide: {
    maxWidth: 400,
    padding: theme.spacing(2),
  },
  hintLight: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.textColor.dark,
    border: `1px solid ${theme.palette.borderColor.primary}`,
    boxShadow: theme.shadows[3],
  },
  inlineContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    flex: '1 1 auto',
    minWidth: 0,
  },
  inlineHint: {
    marginLeft: 10,
    fontSize: 14,
    lineHeight: 1.4,
    flex: '1 1 auto',
    minWidth: 0,
  },
});
